import React from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { driverEventsLink, finalInvoiceBlockers } from '../../Utils/tripClaims';

/**
 * Which bookings stand between this basis and a final Számla, and why.
 *
 * A month-end partner invoice carries every booking of the period, so one
 * bad booking used to grey "Create Számla" out for the whole run and name
 * nothing. This names each one — by reference, linked to its Driver events
 * tab, where the claim is reviewed — off the same `finalInvoiceBlockers`
 * the server's refusal is worded from.
 *
 * Renders nothing when nothing blocks.
 */
function FinalInvoiceBlockedAlert({ bookings = [], className = '' }) {
  const blockers = finalInvoiceBlockers(bookings);

  if (!blockers.length) return null;

  return (
    <Alert variant="warning" className={`py-2 ${className}`} data-testid="final-invoice-blocked">
      <div className="fw-semibold">
        <i className="fa fa-triangle-exclamation me-1" />
        {blockers.length === 1
          ? '1 booking here cannot be finally invoiced yet'
          : `${blockers.length} bookings here cannot be finally invoiced yet`}
      </div>
      <ul className="mb-0 mt-1 ps-3 small">
        {blockers.map((blocker) => (
          <li key={blocker.bookingId || blocker.reference} data-testid="final-invoice-blocker">
            {blocker.bookingId ? (
              <Link to={driverEventsLink(blocker.bookingId)} className="fw-semibold">
                {blocker.reference || 'Booking'}
              </Link>
            ) : (
              <span className="fw-semibold">{blocker.reference || 'Booking'}</span>
            )}
            {` — ${blocker.reason}`}
          </li>
        ))}
      </ul>
      <div className="small mt-1 mb-0">
        Review the claims on each booking (or finish the trip) and the Számla can go out.
        A Díjbekérő or Előlegszámla is not held.
      </div>
    </Alert>
  );
}

export default FinalInvoiceBlockedAlert;
